export const GET_AD_GROUP_STICKY_COLUMNS = "GET_AD_GROUP_STICKY_COLUMNS";
export const GET_AD_GROUP_STICKY_COLUMNS_SUCCESS = "GET_AD_GROUP_STICKY_COLUMNS_SUCCESS";
export const GET_AD_GROUP_STICKY_COLUMNS_ERROR = "GET_AD_GROUP_STICKY_COLUMNS_ERROR";

export const UPDATE_AD_GROUP_STICKY_COLUMNS = "UPDATE_AD_GROUP_STICKY_COLUMNS";
export const UPDATE_AD_GROUP_STICKY_COLUMNS_SUCCESS = "UPDATE_AD_GROUP_STICKY_COLUMNS_SUCCESS";
export const UPDATE_AD_GROUP_STICKY_COLUMNS_ERROR = "UPDATE_AD_GROUP_STICKY_COLUMNS_ERROR";